import React from 'react';

function FeatureSection() {
  return (
    <section className="py-20 md:py-32 px-4 md:px-10 max-w-[1280px] mx-auto" id="vision">
      <div className="flex flex-col md:flex-row justify-between items-end gap-6 mb-16">
        <div className="max-w-xl">
          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4">왜 우리와 함께해야 할까요?</h2>
          <p className="text-gray-500 dark:text-gray-400 text-lg">기존 화훼 시장의 비효율을 제거하고 오직 판매와 성장에만 집중할 수 있는 환경을 제공합니다.</p>
        </div>
        <a className="text-primary font-bold flex items-center gap-1 hover:gap-2 transition-all" href="#">
          전체 서비스 보기 <span className="material-symbols-outlined text-sm">arrow_forward</span>
        </a>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Feature 1 */}
        <div className="group p-8 rounded-2xl bg-surface-light dark:bg-surface-dark border border-gray-100 dark:border-gray-800 hover:border-primary/50 dark:hover:border-primary/50 transition-all duration-300 shadow-sm hover:shadow-xl hover:shadow-primary/5">
          <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6 group-hover:scale-110 transition-transform">
            <span className="material-symbols-outlined">warehouse</span>
          </div>
          <h3 className="text-xl font-bold mb-3">무재고 시스템</h3>
          <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
            재고 폐기율 0%. 본사 중앙 물류 센터에서 주문 즉시 상품을 제작하고 발송하므로 재고 부담이 전혀 없습니다.
          </p>
        </div>
        {/* Feature 2 */}
        <div className="group p-8 rounded-2xl bg-surface-light dark:bg-surface-dark border border-gray-100 dark:border-gray-800 hover:border-primary/50 dark:hover:border-primary/50 transition-all duration-300 shadow-sm hover:shadow-xl hover:shadow-primary/5">
          <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6 group-hover:scale-110 transition-transform">
            <span className="material-symbols-outlined">local_shipping</span>
          </div>
          <h3 className="text-xl font-bold mb-3">자동화 물류</h3>
          <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
            전국 3시간 이내 배송. 주문 접수부터 배송 완료 알림까지 원스톱 자동화 시스템으로 운영 효율을 극대화합니다.
          </p>
        </div>
        {/* Feature 3 */}
        <div className="group p-8 rounded-2xl bg-surface-light dark:bg-surface-dark border border-gray-100 dark:border-gray-800 hover:border-primary/50 dark:hover:border-primary/50 transition-all duration-300 shadow-sm hover:shadow-xl hover:shadow-primary/5">
          <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6 group-hover:scale-110 transition-transform">
            <span className="material-symbols-outlined">diamond</span>
          </div>
          <h3 className="text-xl font-bold mb-3">프리미엄 브랜딩</h3>
          <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
            전문 플로리스트의 디자인과 고급 패키징. 고객의 재구매를 부르는 압도적인 퀄리티를 보장합니다.
          </p>
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
